var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 353,
    viewBox: "0 0 266 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 353,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.448 49.374C33.8027 49.374 33.1207 49.2713 32.402 49.066C31.6833 48.8607 30.9793 48.5527 30.29 48.142C29.6007 47.7313 28.97 47.2107 28.398 46.58C27.8407 45.9347 27.3933 45.1867 27.056 44.336C26.7333 43.4707 26.572 42.488 26.572 41.388C26.572 40.332 26.7333 39.3933 27.056 38.572C27.3933 37.736 27.8407 37.01 28.398 36.394C28.9553 35.778 29.5787 35.272 30.268 34.876C30.9573 34.4653 31.6687 34.1647 32.402 33.974C33.1353 33.7687 33.832 33.666 34.492 33.666C35.24 33.666 35.8927 33.754 36.45 33.93C37.0073 34.106 37.462 34.2893 37.814 34.48C38.166 34.656 38.386 34.7807 38.474 34.854C38.738 35.0153 38.9873 35.1987 39.222 35.404C39.4567 35.6093 39.5813 35.8807 39.596 36.218C39.596 36.394 39.5593 36.57 39.486 36.746C39.4273 36.9073 39.332 37.0833 39.2 37.274C38.9653 37.6113 38.738 37.8607 38.518 38.022C38.3127 38.1687 38.1 38.242 37.88 38.242C37.704 38.242 37.5353 38.198 37.374 38.11C37.2273 38.022 37.0367 37.9047 36.802 37.758C36.6993 37.6847 36.5527 37.5967 36.362 37.494C36.1713 37.3767 35.9147 37.274 35.592 37.186C35.2693 37.0833 34.8587 37.032 34.36 37.032C33.8467 37.032 33.326 37.1273 32.798 37.318C32.2847 37.494 31.808 37.7653 31.368 38.132C30.928 38.4987 30.576 38.968 30.312 39.54C30.048 40.0973 29.916 40.75 29.916 41.498C29.916 42.2753 30.048 42.9427 30.312 43.5C30.5907 44.0573 30.95 44.5193 31.39 44.886C31.83 45.2527 32.3067 45.5313 32.82 45.722C33.348 45.898 33.8613 45.986 34.36 45.986C34.8 45.986 35.174 45.942 35.482 45.854C35.8047 45.766 36.076 45.6633 36.296 45.546C36.5307 45.414 36.7287 45.2967 36.89 45.194C37.0513 45.0913 37.2127 44.996 37.374 44.908C37.55 44.82 37.726 44.776 37.902 44.776C38.1073 44.776 38.3127 44.8567 38.518 45.018C38.738 45.1793 38.958 45.436 39.178 45.788C39.31 45.9787 39.4127 46.1693 39.486 46.36C39.5593 46.536 39.5887 46.712 39.574 46.888C39.574 47.196 39.4567 47.4527 39.222 47.658C38.9873 47.8487 38.738 48.0247 38.474 48.186C38.3567 48.2447 38.1293 48.3767 37.792 48.582C37.4547 48.7727 37.0073 48.9487 36.45 49.11C35.8927 49.286 35.2253 49.374 34.448 49.374ZM54.843 46.866C55.019 47.2327 55.1144 47.548 55.129 47.812C55.1437 48.0613 55.063 48.2887 54.887 48.494C54.7257 48.6847 54.4544 48.8753 54.073 49.066C53.4864 49.3447 53.0317 49.4253 52.709 49.308C52.3864 49.2053 52.0857 48.8607 51.807 48.274L47.495 39.254L43.205 48.274C42.9117 48.846 42.6037 49.1833 42.281 49.286C41.973 49.4033 41.5257 49.3227 40.939 49.044C40.5577 48.868 40.279 48.6847 40.103 48.494C39.9417 48.2887 39.8684 48.054 39.883 47.79C39.8977 47.5113 40.0004 47.1887 40.191 46.822L45.977 34.788C46.1237 34.4947 46.3364 34.26 46.615 34.084C46.9084 33.908 47.209 33.82 47.517 33.82C47.737 33.82 47.9424 33.864 48.133 33.952C48.3237 34.0253 48.4924 34.1353 48.639 34.282C48.8004 34.4287 48.9324 34.6047 49.035 34.81L54.843 46.866ZM43.799 45.612L45.163 42.774H49.849L51.213 45.612H43.799ZM58.0327 49.198C57.5047 49.198 57.1234 49.1173 56.8887 48.956C56.654 48.7947 56.5074 48.582 56.4487 48.318C56.4047 48.054 56.3827 47.7827 56.3827 47.504V35.47C56.3827 35.1913 56.4047 34.9273 56.4487 34.678C56.5074 34.4287 56.654 34.2233 56.8887 34.062C57.1234 33.9007 57.512 33.82 58.0547 33.82H62.6307C63.232 33.82 63.848 33.93 64.4787 34.15C65.1094 34.37 65.6887 34.7073 66.2167 35.162C66.7447 35.6167 67.17 36.1813 67.4927 36.856C67.8154 37.5307 67.9767 38.33 67.9767 39.254C67.9767 39.87 67.8814 40.464 67.6907 41.036C67.5147 41.608 67.2434 42.136 66.8767 42.62C66.51 43.104 66.0554 43.522 65.5127 43.874C64.97 44.2113 64.3467 44.4533 63.6427 44.6H59.7267V47.526C59.7267 47.8047 59.6974 48.076 59.6387 48.34C59.58 48.5893 59.4334 48.7947 59.1987 48.956C58.964 49.1173 58.5754 49.198 58.0327 49.198ZM67.3167 48.758C66.774 49.154 66.3414 49.308 66.0187 49.22C65.696 49.132 65.3587 48.846 65.0067 48.362L61.1347 42.818L64.8967 42.334L67.7347 46.404C67.984 46.756 68.138 47.0567 68.1967 47.306C68.27 47.5553 68.2334 47.79 68.0867 48.01C67.9547 48.23 67.698 48.4793 67.3167 48.758ZM59.7267 41.3H62.7847C62.99 41.3 63.2027 41.2633 63.4227 41.19C63.6427 41.102 63.8407 40.9773 64.0167 40.816C64.1927 40.6547 64.3394 40.442 64.4567 40.178C64.574 39.914 64.6327 39.5987 64.6327 39.232C64.6327 38.8067 64.5447 38.44 64.3687 38.132C64.2074 37.824 63.9727 37.5893 63.6647 37.428C63.3567 37.252 62.9974 37.164 62.5867 37.164H59.7267V41.3ZM71.3059 49.198C70.7926 49.198 70.4186 49.1173 70.1839 48.956C69.9639 48.7947 69.8172 48.5893 69.7439 48.34C69.6706 48.076 69.6339 47.7973 69.6339 47.504V35.47C69.6339 35.1913 69.6632 34.9273 69.7219 34.678C69.7806 34.414 69.9272 34.2013 70.1619 34.04C70.3966 33.8787 70.7852 33.8053 71.3279 33.82H75.2879C76.3439 33.82 77.3266 34.0107 78.2359 34.392C79.1452 34.7733 79.9446 35.3087 80.6339 35.998C81.3232 36.6873 81.8586 37.494 82.2399 38.418C82.6212 39.342 82.8119 40.3467 82.8119 41.432C82.8119 42.532 82.6212 43.5587 82.2399 44.512C81.8586 45.4507 81.3232 46.272 80.6339 46.976C79.9446 47.6653 79.1379 48.208 78.2139 48.604C77.3046 49 76.3072 49.198 75.2219 49.198H71.3059ZM72.9779 45.832H75.2879C76.0799 45.832 76.7912 45.6487 77.4219 45.282C78.0526 44.9007 78.5512 44.3873 78.9179 43.742C79.2846 43.0967 79.4679 42.356 79.4679 41.52C79.4679 40.684 79.2846 39.936 78.9179 39.276C78.5512 38.616 78.0526 38.1027 77.4219 37.736C76.7912 37.3547 76.0726 37.164 75.2659 37.164H72.9779V45.832ZM91.6164 49.198C91.0884 49.198 90.707 49.1247 90.4724 48.978C90.2377 48.8167 90.091 48.604 90.0324 48.34C89.9737 48.076 89.9444 47.8047 89.9444 47.526V35.492C89.9444 35.1987 89.9664 34.9273 90.0104 34.678C90.069 34.4287 90.2157 34.2233 90.4504 34.062C90.685 33.9007 91.0737 33.82 91.6164 33.82C92.1737 33.82 92.5624 33.9007 92.7824 34.062C93.017 34.2233 93.1564 34.4287 93.2004 34.678C93.259 34.9273 93.2884 35.1987 93.2884 35.492V46.294H99.3164C99.5657 46.294 99.8004 46.316 100.02 46.36C100.24 46.404 100.416 46.5287 100.548 46.734C100.695 46.9393 100.768 47.2767 100.768 47.746C100.768 48.2007 100.695 48.538 100.548 48.758C100.402 48.9633 100.218 49.088 99.9984 49.132C99.793 49.176 99.5657 49.198 99.3164 49.198H91.6164ZM109.248 49.418C108.192 49.418 107.194 49.22 106.256 48.824C105.332 48.4133 104.518 47.856 103.814 47.152C103.124 46.4333 102.574 45.6047 102.164 44.666C101.768 43.7273 101.57 42.7153 101.57 41.63C101.57 40.53 101.76 39.5033 102.142 38.55C102.538 37.582 103.073 36.7313 103.748 35.998C104.437 35.2647 105.236 34.6927 106.146 34.282C107.055 33.8713 108.03 33.666 109.072 33.666C110.128 33.666 111.118 33.8713 112.042 34.282C112.98 34.678 113.794 35.2353 114.484 35.954C115.173 36.6727 115.716 37.5087 116.112 38.462C116.522 39.4153 116.728 40.4493 116.728 41.564C116.728 42.6347 116.53 43.6467 116.134 44.6C115.752 45.5387 115.217 46.3747 114.528 47.108C113.838 47.8267 113.039 48.3913 112.13 48.802C111.235 49.2127 110.274 49.418 109.248 49.418ZM109.138 46.074C109.724 46.074 110.274 45.9567 110.788 45.722C111.301 45.4873 111.748 45.172 112.13 44.776C112.526 44.3653 112.826 43.8887 113.032 43.346C113.252 42.7887 113.362 42.1873 113.362 41.542C113.362 40.926 113.252 40.3467 113.032 39.804C112.812 39.2467 112.504 38.7627 112.108 38.352C111.726 37.9267 111.279 37.5967 110.766 37.362C110.267 37.1273 109.724 37.01 109.138 37.01C108.566 37.01 108.023 37.1273 107.51 37.362C107.011 37.5967 106.564 37.9267 106.168 38.352C105.786 38.7627 105.478 39.2467 105.244 39.804C105.024 40.3467 104.914 40.9333 104.914 41.564C104.914 42.18 105.024 42.7667 105.244 43.324C105.478 43.8667 105.786 44.3433 106.168 44.754C106.564 45.1647 107.011 45.4873 107.51 45.722C108.008 45.9567 108.551 46.074 109.138 46.074ZM125.563 49.374C124.918 49.374 124.236 49.2713 123.517 49.066C122.799 48.8607 122.095 48.5527 121.405 48.142C120.716 47.7313 120.085 47.2107 119.513 46.58C118.956 45.9347 118.509 45.1867 118.171 44.336C117.849 43.4707 117.687 42.488 117.687 41.388C117.687 40.332 117.849 39.3933 118.171 38.572C118.509 37.736 118.956 37.01 119.513 36.394C120.071 35.778 120.694 35.272 121.383 34.876C122.073 34.4653 122.784 34.1647 123.517 33.974C124.251 33.7687 124.947 33.666 125.607 33.666C126.355 33.666 127.008 33.754 127.565 33.93C128.123 34.106 128.577 34.2893 128.929 34.48C129.281 34.656 129.501 34.7807 129.589 34.854C129.853 35.0153 130.103 35.1987 130.337 35.404C130.572 35.6093 130.697 35.8807 130.711 36.218C130.711 36.394 130.675 36.57 130.601 36.746C130.543 36.9073 130.447 37.0833 130.315 37.274C130.081 37.6113 129.853 37.8607 129.633 38.022C129.428 38.1687 129.215 38.242 128.995 38.242C128.819 38.242 128.651 38.198 128.489 38.11C128.343 38.022 128.152 37.9047 127.917 37.758C127.815 37.6847 127.668 37.5967 127.477 37.494C127.287 37.3767 127.03 37.274 126.707 37.186C126.385 37.0833 125.974 37.032 125.475 37.032C124.962 37.032 124.441 37.1273 123.913 37.318C123.4 37.494 122.923 37.7653 122.483 38.132C122.043 38.4987 121.691 38.968 121.427 39.54C121.163 40.0973 121.031 40.75 121.031 41.498C121.031 42.2753 121.163 42.9427 121.427 43.5C121.706 44.0573 122.065 44.5193 122.505 44.886C122.945 45.2527 123.422 45.5313 123.935 45.722C124.463 45.898 124.977 45.986 125.475 45.986C125.915 45.986 126.289 45.942 126.597 45.854C126.92 45.766 127.191 45.6633 127.411 45.546C127.646 45.414 127.844 45.2967 128.005 45.194C128.167 45.0913 128.328 44.996 128.489 44.908C128.665 44.82 128.841 44.776 129.017 44.776C129.223 44.776 129.428 44.8567 129.633 45.018C129.853 45.1793 130.073 45.436 130.293 45.788C130.425 45.9787 130.528 46.1693 130.601 46.36C130.675 46.536 130.704 46.712 130.689 46.888C130.689 47.196 130.572 47.4527 130.337 47.658C130.103 47.8487 129.853 48.0247 129.589 48.186C129.472 48.2447 129.245 48.3767 128.907 48.582C128.57 48.7727 128.123 48.9487 127.565 49.11C127.008 49.286 126.341 49.374 125.563 49.374ZM134.002 49.198C133.474 49.198 133.093 49.1247 132.858 48.978C132.623 48.8167 132.477 48.604 132.418 48.34C132.374 48.076 132.352 47.8047 132.352 47.526V35.47C132.352 35.1913 132.374 34.9273 132.418 34.678C132.477 34.414 132.623 34.2087 132.858 34.062C133.093 33.9007 133.481 33.82 134.024 33.82C134.581 33.82 134.97 33.9007 135.19 34.062C135.425 34.2233 135.564 34.4287 135.608 34.678C135.667 34.9273 135.696 35.1987 135.696 35.492V39.298L140.404 34.37C140.697 34.0767 140.961 33.8713 141.196 33.754C141.445 33.6367 141.695 33.6147 141.944 33.688C142.208 33.7613 142.487 33.9447 142.78 34.238C143.279 34.6927 143.528 35.096 143.528 35.448C143.543 35.7853 143.337 36.1667 142.912 36.592L137.852 41.52L142.956 46.404C143.411 46.8587 143.623 47.2693 143.594 47.636C143.579 47.988 143.323 48.3693 142.824 48.78C142.472 49.0733 142.164 49.2567 141.9 49.33C141.651 49.418 141.416 49.396 141.196 49.264C140.976 49.1467 140.727 48.934 140.448 48.626L135.696 43.676V47.548C135.696 47.8267 135.667 48.098 135.608 48.362C135.564 48.6113 135.425 48.8167 135.19 48.978C134.955 49.1247 134.559 49.198 134.002 49.198Z",
    fill: "#434343"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 132.499,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(-12.879 7 132.499)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2352,
    y: 185.196,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(-12.879 65.2352 185.196)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.2394,
    y1: 213.589,
    x2: 78.3532,
    y2: 245.066,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.0575,
    y1: 218.884,
    x2: 104.535,
    y2: 239.771,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.6263,
    y1: 145.736,
    x2: 63.7401,
    y2: 177.213,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4445,
    y1: 151.031,
    x2: 89.922,
    y2: 171.918,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 119.229,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(-6.50099 73 119.229)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.021,
    y: 178.069,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(-6.50099 125.021 178.069)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.66,
    y1: 210.064,
    x2: 131.407,
    y2: 239.026,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.052,
    y1: 212.418,
    x2: 158.015,
    y2: 236.672,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.675,
    y1: 141.007,
    x2: 124.422,
    y2: 169.97,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.067,
    y1: 143.362,
    x2: 151.03,
    y2: 167.615,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.467,
    y: 112,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(9.07858 163.467 112)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.773,
    y: 182.65,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(9.07858 197.773 182.65)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.694,
    y1: 221.698,
    x2: 187.553,
    y2: 243.082,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.431,
    y1: 216.819,
    x2: 213.815,
    y2: 247.961,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.513,
    y1: 153.303,
    x2: 199.371,
    y2: 174.687,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.25,
    y1: 148.424,
    x2: 225.634,
    y2: 179.565,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 97.5,
    width: 67,
    height: 76,
    rx: 33.5,
    stroke: "#434343",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_12_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 136,
    width: 124,
    height: 127,
    rx: 30,
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 193,
    width: 15,
    height: 26,
    rx: 7.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 193,
    width: 15,
    height: 26,
    rx: 7.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 193,
    width: 15,
    height: 26,
    rx: 7.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 193,
    width: 15,
    height: 26,
    rx: 7.5,
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_58",
    x: 4.70895,
    y: 106.455,
    width: 153.048,
    height: 184.075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12_58",
    x: 70.7089,
    y: 106,
    width: 138.23,
    height: 174.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12_58",
    x: 136.709,
    y: 112,
    width: 144.429,
    height: 178.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_12_58",
    x: 71,
    y: 136,
    width: 124,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 252,
    fill: "white",
    transform: "translate(24 76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard02);
export default __webpack_public_path__ + "static/media/card-02.d9a73149d60a53c4685b0072bffa0c30.svg";
export { ForwardRef as ReactComponent };